import { get, post, req } from '@/plugins/axios'

/**
* 查询客户店铺下的商品
* @param {Object} data
*/
interface SPD{
  bindStatus:number
  thirdItemName:string
  itemRemark:number
  itemRemarkList:number
  productTitle:number
  pageNum:number
  pageSize:number
}
export function searchShopProduct (data: SPD) {
  return post('/api/thirdShopItem/pageThirdShopItem', data).then((res) => {
    console.log('searchShopProduct', res)
    res.data.records = res.data.records.map((item:any) => {
      return {
        ...item,
        additionCn: {
          ...(item.additions?.find((v:{warehouseCountry:string}) => v.warehouseCountry === 'CN') ?? {}),
          ...(item.additionCheckTypeList?.find((v:{warehouseCountry:string}) => v.warehouseCountry === 'CN') ?? {})
        },
        additionKr: {
          ...(item.additions?.find((v:{warehouseCountry:string}) => v.warehouseCountry === 'KR') ?? {}),
          ...(item.additionCheckTypeList?.find((v:{warehouseCountry:string}) => v.warehouseCountry === 'KR') ?? {})
        }
      }
    })
    return res
  })
}

/**
* 修改商品番号
* @param {Object} data
*/
export function updateCustomerProductNo (data: any) {
  return post('/api/thirdShopItem/updateItemRemark', data)
}

/**
* 编辑商品附加项
* @param {Object} data
*/
export function editAddition (data: any) {
  return post('/api/thirdShopItem/updateItemAddition', data)
}

/**
* 同步单个商品
*/
export function syncGoods (data: any) {
  return req('/api/thirdShopItem/refreshItem', data)
}

/**
* 同步全部商品
*/
export function syncAllGoods (data: any) {
  return req('/api/thirdShopItem/syncItems', data)
}

/**
* 删除店铺商品-批量/单个
* @param {Object} data
*/
export function batchDeleteProduct (data: any) {
  return post('/api/thirdShopItem/batchDelete', data)
}

/**
* 查询某商品的sku
* @param {Object} data
*/
export function listShopProductSku (data: any) {
  return req('/api/thirdShopItem/querySkuList', data)
}

/**
* 取得店铺商品详情
* @param {Object} params
*/
export function getShopProductDetail (params: any) {
  return get('/api/thirdShopItem/getShopItemDetail', { params })
}

/**
* 绑定店铺商品Sku
* @param {Object} data
*/
export function bindShopProductSku (data: any) {
  return post('/api/thirdShopItem/bindSku', data)
}

/**
* 解绑店铺商品sku
* @param {Object} data
*/
export function unbindShopProductSku (data: any) {
  return post('/api/thirdShopItem/unbindSku', data)
}

/**
* 绑定店铺商品
* @param {Object} data
*/
// export function bindShopProduct (data: any) {
//   return post('/api/shopProduct/bindShopProduct', data)
// }

/**
* 解绑店铺商品
* @param {Object} data
*/
// export function unbindShopProduct (data: any) {
//   return post('/api/shopProduct/unbindShopProduct', data)
// }

/**
* 删除店铺商品sku
* @param {Object} data
*/
// export function deleteShopSku (data: any) {
//   return post('/api/shopProductSku/deleteShopSku', data)
// }

/**
* 删除店铺订单下的商品
* @param {Object} data
*/
// export function deleteShopOrderItem (data: any) {
//   return post('/api/shopOrderItem/deleteShopOrderItem', data)
// }

/**
* 获取商品上次更新时间
*/
export function getLastTime () {
  return get('/api/thirdShopItem/getLastTime')
}

/**
* 同款商品搜索
*/
export function similarProduct (params: any) {
  return get('/goods/search/same/style/product/query', { params })
}

/**
* 同款商品入库
*/
export function similarProductCode (data: any) {
  return post('/goods/product/samle/style/product/put/in/' + data)
}

/**
* 寻源单列表（前台）关联商品用
*/
export function showOemList (data: any) {
  return post('/order/searchSourceOrder/show/listRelated', data)
}

/**
* 关联商品库修改sku下的附加项
*/
export function thirdShopEditAdditionListApi (data: any) {
  return post('/api/thirdShopItem/updateItemSkuAddition', data)
}
